export enum UpdateModeratorActionTypes {
  UPDATING = 'moderators/UPDATING',
  UPDATED = 'moderators/UPDATED',
  ERROR = 'moderators/UPDATE-ERROR',
}
